var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0158 13.0332C9.83029 13.0332 7.89579 10.7499 7.89579 8.51664V7.83324C7.93534 6.7791 8.39124 5.78365 9.16354 5.06509C9.93584 4.34653 10.9615 3.96349 12.0158 3.99994C13.07 3.96349 14.0957 4.34653 14.868 5.06509C15.6403 5.78365 16.0962 6.7791 16.1358 7.83324V8.51664C16.1359 10.7499 14.2012 13.0332 12.0158 13.0332ZM19.3066 19.9999H4.72499C4.61538 20.0022 4.50919 19.9618 4.42892 19.8871C4.34864 19.8124 4.30061 19.7094 4.29499 19.5999V17.9332C4.28393 17.2631 4.48381 16.6065 4.86636 16.0562C5.24892 15.5059 5.79479 15.0897 6.42679 14.8666C8.21891 14.2475 10.1018 13.9321 11.9979 13.9332C13.8932 13.9403 15.7748 14.2555 17.569 14.8666C18.201 15.0897 18.7468 15.5059 19.1294 16.0562C19.5119 16.6065 19.7118 17.2631 19.7007 17.9332V19.5999C19.7051 19.6531 19.6981 19.7066 19.6799 19.7567C19.6618 19.8069 19.633 19.8525 19.5955 19.8905C19.5581 19.9285 19.5129 19.9579 19.463 19.9768C19.4132 19.9957 19.3598 20.0036 19.3066 19.9999Z",
    fill: "#BD161D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_114",
    x1: 15.3684,
    y1: 4.7977,
    x2: 11.5505,
    y2: 19.8875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.8f0506e935c2cba14aac4446ce95fa79.svg";
export { ForwardRef as ReactComponent };